// Requirement: `#6990` - the order of a job's crew rows. Before this, rows within a job kept
// whatever order Neo4j returned them in (the report is fetched with `sort: null`), which could
// change between loads.
//
// Ranked by the saved phase checkboxes in column order, each one compared in turn: a member with
// Reg. Crew + Packing sorts above one with Reg. Crew alone. Then by name, then by id so two members
// with the same name still land in a fixed order.

export const CREW_ORDER_PHASES = [
  'crewLeadEnabled',
  'flatRateEnabled',
  'packingEnabled',
  'unpackingEnabled',
  'loadEnabled',
  'unloadEnabled',
] as const;

export type CrewOrderRow = Record<typeof CREW_ORDER_PHASES[number], boolean> & {
  crewMemberName: string;
  crewMemberId: string;
};

export function compareCrewWithinJob(a: CrewOrderRow, b: CrewOrderRow): number {
  for (const phase of CREW_ORDER_PHASES) {
    if (a[phase] !== b[phase]) {
      return a[phase] ? -1 : 1;
    }
  }
  return a.crewMemberName.localeCompare(b.crewMemberName, undefined, { sensitivity: 'base' })
    || a.crewMemberId.localeCompare(b.crewMemberId);
}
